import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Download, Share2, Printer, FileText, Calendar, User } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
export function DocumentViewerPage() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  // Mock document data
  const document = {
    id: 1,
    title: 'Anggaran Dasar (AD) ATIOS',
    description: 'Dokumen anggaran dasar organisasi ATIOS yang mengatur struktur dan tujuan organisasi',
    category: 'Governance',
    fileSize: '2.5 MB',
    fileType: 'PDF',
    version: 'v2.0',
    lastUpdated: 'December 15, 2024',
    author: 'Komite Pusat ATIOS',
    downloads: 245
  };
  const handleDownload = () => {
    alert('Mengunduh dokumen...');
  };
  const handlePrint = () => {
    window.print();
  };
  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: document.title,
        text: document.description,
        url: window.location.href
      });
    } else {
      alert('Link disalin ke clipboard!');
    }
  };
  return <div className="min-h-screen bg-white" data-id="element-2386">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2387">
        {/* Header */}
        <div className="mb-8" data-id="element-2388">
          <Button variant="ghost" onClick={() => navigate('/knowledge-center')} className="mb-4" data-id="element-2389">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-2390" />
            Kembali ke Knowledge Center
          </Button>

          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-2391">
            <div className="flex-1" data-id="element-2392">
              <div className="flex items-center gap-3 mb-2" data-id="element-2393">
                <h1 className="text-3xl font-semibold text-neutral-900" data-id="element-2394">
                  {document.title}
                </h1>
                <Badge variant="primary" data-id="element-2395">{document.category}</Badge>
              </div>
              <p className="text-neutral-600" data-id="element-2396">{document.description}</p>
            </div>

            <div className="flex gap-2" data-id="element-2397">
              <Button variant="secondary" size="sm" onClick={handleShare} data-id="element-2398">
                <Share2 className="w-4 h-4 mr-2" data-id="element-2399" />
                Bagikan
              </Button>
              <Button variant="secondary" size="sm" onClick={handlePrint} data-id="element-2400">
                <Printer className="w-4 h-4 mr-2" data-id="element-2401" />
                Cetak
              </Button>
              <Button onClick={handleDownload} data-id="element-2402">
                <Download className="w-4 h-4 mr-2" data-id="element-2403" />
                Unduh
              </Button>
            </div>
          </div>
        </div>

        {/* Document Info */}
        <Card className="mb-8" data-id="element-2404">
          <CardContent className="p-6" data-id="element-2405">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-2406">
              <div data-id="element-2407">
                <p className="text-sm text-neutral-500 mb-1" data-id="element-2408">Tipe File</p>
                <div className="flex items-center gap-2" data-id="element-2409">
                  <FileText className="w-4 h-4 text-atios-primary" data-id="element-2410" />
                  <p className="font-medium text-neutral-900" data-id="element-2411">
                    {document.fileType}
                  </p>
                </div>
              </div>
              <div data-id="element-2412">
                <p className="text-sm text-neutral-500 mb-1" data-id="element-2413">Ukuran</p>
                <p className="font-medium text-neutral-900" data-id="element-2414">
                  {document.fileSize}
                </p>
              </div>
              <div data-id="element-2415">
                <p className="text-sm text-neutral-500 mb-1" data-id="element-2416">Versi</p>
                <p className="font-medium text-neutral-900" data-id="element-2417">
                  {document.version}
                </p>
              </div>
              <div data-id="element-2418">
                <p className="text-sm text-neutral-500 mb-1" data-id="element-2419">Unduhan</p>
                <p className="font-medium text-neutral-900" data-id="element-2420">
                  {document.downloads}
                </p>
              </div>
              <div data-id="element-2421">
                <p className="text-sm text-neutral-500 mb-1" data-id="element-2422">Penulis</p>
                <div className="flex items-center gap-2" data-id="element-2423">
                  <User className="w-4 h-4 text-neutral-400" data-id="element-2424" />
                  <p className="font-medium text-neutral-900" data-id="element-2425">
                    {document.author}
                  </p>
                </div>
              </div>
              <div data-id="element-2426">
                <p className="text-sm text-neutral-500 mb-1" data-id="element-2427">
                  Terakhir Diperbarui
                </p>
                <div className="flex items-center gap-2" data-id="element-2428">
                  <Calendar className="w-4 h-4 text-neutral-400" data-id="element-2429" />
                  <p className="font-medium text-neutral-900" data-id="element-2430">
                    {document.lastUpdated}
                  </p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Document Preview */}
        <Card data-id="element-2431">
          <CardContent className="p-0" data-id="element-2432">
            <div className="bg-neutral-50 border-b border-neutral-200 p-4" data-id="element-2433">
              <p className="text-sm text-neutral-600 text-center" data-id="element-2434">
                Preview Dokumen
              </p>
            </div>
            <div className="p-8 min-h-[600px] bg-white" data-id="element-2435">
              {/* PDF Viewer would go here */}
              <div className="flex items-center justify-center h-full" data-id="element-2436">
                <div className="text-center" data-id="element-2437">
                  <FileText className="w-16 h-16 text-neutral-300 mx-auto mb-4" data-id="element-2438" />
                  <p className="text-neutral-600 mb-4" data-id="element-2439">
                    Preview dokumen akan ditampilkan di sini
                  </p>
                  <Button onClick={handleDownload} data-id="element-2440">
                    <Download className="w-4 h-4 mr-2" data-id="element-2441" />
                    Unduh untuk Melihat
                  </Button>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}